// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=type-enum-js|name=MessageRole|schemaHash=34e956388ea44913bf8136436ccd9949b7bf9592

/**
 *  - User: 1
 *  - Assistant: 2
 */
export var MessageRole = /* @__PURE__ */ ((MessageRole) => {
  MessageRole[MessageRole["User"] = 1] = "User";
  MessageRole[MessageRole["Assistant"] = 2] = "Assistant";
  return MessageRole;
})(MessageRole || {});
